import { PublisherInterface } from '@chili-publish/publisher-interface'
import { removeSeparateSpacesTextFlow } from 'shared/utils/chili'

const fixTextFlowFontFamily = (textFlow: string) => {
  const parser = new DOMParser()

  const xmlDoc = parser.parseFromString(textFlow, 'application/xml')
  const spans = xmlDoc.querySelectorAll('span')

  let wasModified = false

  spans.forEach(span => {
    if (!span.getAttribute('fontFamily')) {
      span.setAttribute('fontFamily', 'Inter_Regular')
      wasModified = true
    }
  })

  const serializer = new XMLSerializer()

  return {
    wasModified,
    newTextFlow: serializer.serializeToString(xmlDoc)
  }
}

export const useTextMigration = ({
  publisherConnector
}: {
  publisherConnector: PublisherInterface
}) => {
  const migrate = async () => {
    const logs: Record<string, { from: string; to: string }> = {}

    const frames = (await publisherConnector.getObject(
      'document.pages[0].frames'
    )) as any[]

    const framesCount = Number(frames.length)

    let counter = 0
    for (let i = 0; i < framesCount; i++) {
      const frame = (await publisherConnector.getObject(
        `document.pages[0].frames[${i}]`
      )) as any
      const composerSelector = `document.pages[0].frames[${frame.id}].textFlow.composer`

      if (frame.type === 'text') {
        const { textFlow } = (await publisherConnector.getObject(
          composerSelector
        )) as { textFlow: string }

        const { newTextFlow: newTextFlowFontFamily, wasModified: wasModifiedFontFamily } = fixTextFlowFontFamily(textFlow)
        const { newTextFlow: finalTextFlow, wasModified: wasModifiedSpaces } = removeSeparateSpacesTextFlow(newTextFlowFontFamily)

        if (!wasModifiedFontFamily || !wasModifiedSpaces) {
          continue
        }

        logs[frame.id] = {
          from: textFlow,
          to: finalTextFlow
        }

        counter++

        await publisherConnector.executeFunction(
          frame.javaScriptDescriptor,
          'ImportTextFlow',
          finalTextFlow
        )
        console.log('Text flow modified successfully')
      }
    }
    await publisherConnector?.executeFunction(
      'document.selectedFrames',
      'Clear'
    )

    console.log(`%c${counter} text frames fixed`, 'color: green')
    console.log(logs)
  }

  return {
    migrate
  }
}
